import { useI18nContext } from "i18n/i18n-react"
import React from "react"

import "./Print.scss"

function Print() {
  const { LL } = useI18nContext()
  const handlePrint = () => {
    window.print()
  }

  // this will be Print Generic Button
  return (
    <div className="Print">
      <button className="c-btn tertiary" onClick={handlePrint} role="link">
        {LL.generic.printLabel()}
      </button>
    </div>
  )
}

export default Print
